import { Component, inject, OnInit, HostListener } from '@angular/core';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '../../../../../../shared/components/api/models/filterItem.model';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { CardUserComponent } from '@app/shared/components/card-user/card-user.component';
import { MessageService, MenuItem, ConfirmationService } from 'primeng/api';
import { DrawerModule } from 'primeng/drawer';
import { CommonModule } from '@angular/common';
import { DetalheUtilizadorComponent } from '../detalhe-utilizador/detalhe-utilizador.component';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { take } from 'rxjs/operators';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PasswordModule } from 'primeng/password';
import { Menu } from 'primeng/menu';
import e from 'express';

interface UserRecord {
  id: string;
  userName: string;
  email: string;
  roles: Array<string>;
}

interface GroupOption {
  id: string;
  nome: string;
}

@Component({
  selector: 'app-lista-utilizadores',
  imports: [
    SearchBarComponent,
    DataVoidComponent,
    PaginatorControlComponent,
    CardUserComponent,
    DrawerModule,
    CommonModule,
    DetalheUtilizadorComponent,
    SkeletonLoaderComponent,
    DialogModule,
    InputTextModule,
    ButtonModule,
    ReactiveFormsModule,
    SelectModule,
    ConfirmDialogModule,
    PasswordModule
  ],
  providers: [
    EnumService,
    UtilizadoresService,
    ConfirmationService
  ],
  templateUrl: './lista-utilizadores.component.html',
  styleUrl: './lista-utilizadores.component.scss',
  standalone: true
})
export class ListaUtilizadoresComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly utilizadorService = inject(UtilizadoresService);
  private readonly fb = inject(FormBuilder);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly enumService = inject(EnumService);

  visible: boolean = false;
  showDesassociateModal: boolean = false;
  loading: boolean = false;
  showModalAssociate = false;
  disabled_btn: boolean = false;
  labelStatus: string = '';
  pagination: Pagination<any> = new Pagination<any>();
  user: any;
  dissassociateForm!: FormGroup;
  associateForm!: FormGroup;
  selectedUser?: UserRecord;
  currentFilters: any;
  listUsers: any[] = [];
  listRoles: GroupOption[] = [];
  listRolesByUser: GroupOption[] = [];

  estadoUserOptins: any[] = [
    { value: true, label: 'Activo' },
    { value: false, label: 'Inactivo' }
  ];

  actions = (rowData: any): MenuItem[] => [
    {
      label: 'Ver detalhes',
      icon: 'pi pi-eye',
      command: () => this.verDetalhe(rowData),
    },
    {
      id: 'associate',
      label: 'Adicionar Permissão',
      icon: 'pi pi-user-plus',
      command: () => this.openAssociateModal(rowData),
    },
    {
      id: 'disassociate',
      label: 'Remover Permissão',
      icon: 'pi pi-user-minus',
      command: () => this.openDisassociateModal(rowData),
    },
    {
      label: this.getActionLabel(rowData),
      icon: 'pi pi-key',
      command: () => this.toggleEstado(rowData),
    },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'Nome',
      placeholder: 'Pesquise pelo nome',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'date',
      controlName: 'DataCriacao',
      placeholder: 'Data de registo ',
    },
    {
      type: 'dropdown',
      controlName: 'Ativo',
      options: this.estadoUserOptins,
      placeholder: 'Seleccione o estado',
      optionLabel: 'label',
      optionValue: 'value'
    }
  ];

  ngOnInit(): void {
    this.getUtilizadores();
    this.initForms();
  }

  initForms() {
    this.dissassociateForm = this.fb.group({
      userName: [{ value: '', disabled: true }, Validators.required],
      roleId: [null, Validators.required],
    });

    this.associateForm = this.fb.group({
      userName: [{ value: '', disabled: true }, Validators.required],
      roleId: [null, Validators.required],
    });
  }

  // Acoes de menu
  verDetalhe(user: any) {
    this.user = user;
    this.visible = true;
  }

  getActionLabel(rowData: any): string {
    return rowData?.ativo ? 'Desativar' : 'Ativar';
  }

  getUtilizadores(filters?: any) {
    this.loading = true;
    const params = {
      ...this.currentFilters,
      ...filters,
      pageSize: this.pagination.pageSize || 5,
      pageNumber: this.pagination.pageNumber || 1,
      orderBy: 'id desc',
    }
    this.utilizadorService.list(params).subscribe({
      next: (res) => {
        this.pagination = new Pagination().deserialize(res);
        this.listUsers = res.data;
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Falha',
          detail: 'Não foi possível carregar utilizadores',
          life: 5000
        });
      }
    })
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getUtilizadores();
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => {
          // Permite false e 0, mas exclui null, undefined e strings vazias
          return value === false || value === 0 || (value !== null && value !== undefined && value !== '');
        }
      ),
    );
    this.currentFilters = filters;
    this.getUtilizadores();
  }

  getRoles() {
    this.utilizadorService.getRoles()
      .pipe(take(1))
      .subscribe({
        next: (roles) => {
          this.listRoles = roles.data.map((r: any) => ({
            id: r.id,
            name: r.name,
          }));
        },
        error: (err) => this.handleError('Erro ao buscar permissões', err),
      });
  }

  private openAssociateModal(user: UserRecord): void {
    this.selectedUser = user;
    this.getRoles();
    this.showModalAssociate = true;
    this.associateForm.patchValue({ userName: user.userName, roleId: null });
  }

  private openDisassociateModal(user: UserRecord): void {
    this.showDesassociateModal = true;
    this.selectedUser = user;
    this.listRolesByUser = user.roles.map((nome: any) => ({
      id: nome?.roleId.toString(),
      nome: nome?.roleName,
    }));
    this.dissassociateForm.patchValue({ userName: user.userName, roleId: null });
  }

  trackByGroup = (_: number, group: GroupOption) => group.id;

  RemoveUserFromGroup(userName: string, roleId: string, roleName: string): void {
    if (!userName || !roleId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Dados inválidos para remoção.',
        life: 5000
      });
      return;
    }

    this.confirmationService.confirm({
      message: `Tem certeza que deseja remover a permissão "${roleName}" do usuário "${userName}"?`,
      header: 'Confirmar Remoção',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        const params = {
          userId: this.selectedUser?.id,
          roleId: roleId,
        };
        this.utilizadorService
          .deleteRoleByUserId(params)
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Permissão removida com sucesso.`,
                life: 5000
              });
              this.showDesassociateModal = false;
              this.dissassociateForm.reset();
              this.confirmationService.close();
              this.listRolesByUser = this.listRolesByUser.filter(g => g.id !== roleId);
              this.getUtilizadores();
            },
            error: (err) => {
              this.handleError('Falha ao remover permissão', err);
            }
          });
      },
      reject: () => {
        this.showDesassociateModal = false;
        this.dissassociateForm.reset();
        this.confirmationService.close();
        this.messageService.add({
          severity: 'info',
          summary: 'Ação Cancelada',
          detail: 'Desassociação cancelada.',
          life: 5000
        });
      },
    });
  }

  private closeAssociateModal(): void {
    this.showModalAssociate = false;
    this.associateForm.reset();
    this.selectedUser = undefined;
    this.disabled_btn = false;
  }

  private handleError(summary: string, error: any): void {
    console.error(summary, error);
    this.messageService.add({ severity: 'error', summary, detail: summary });
  }

  saveUser(): void {
    if (this.associateForm.invalid || !this.selectedUser) {
      this.associateForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, seleccione uma permissão.',
        life: 5000
      });
      return;
    }
    this.loading = true;
    const params = {
      userId: this.selectedUser.id,
      roleId: this.associateForm.value.roleId,
    }
    this.utilizadorService
      .addRoleToUser(params).subscribe({
        next: (res) => {
          if (res.retorno.codigo === 200) {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Permissão associada com sucesso.',
              life: 5000
            });
            this.disabled_btn = true;
            this.loading = false;
            this.closeAssociateModal();
            this.getUtilizadores();
          } else {
            this.closeAssociateModal();
            this.loading = false;
            this.disabled_btn = true;
            this.messageService.add({
              severity: 'warn',
              summary: 'Aviso',
              detail: res.retorno.mensagem || 'Falha ao associar permissão',
              life: 5000
            });
          }
        },
        error: (err) => {
          this.loading = false;
          this.handleError('Falha ao associar usuário', err);
        }
      })
  }

  cancel(): void {
    this.closeAssociateModal();
  }

  // controle de menus
  openedMenu: Menu | null = null;

  setOpenedMenu(menu: Menu) {
    if (this.openedMenu && this.openedMenu !== menu) {
      this.openedMenu.hide();
    }
    this.openedMenu = menu;
  }

  clearOpenedMenu() {
    this.openedMenu = null;
  }

  @HostListener('document:click')
  onDocumentClick() {
    if (this.openedMenu) {
      this.openedMenu.hide();
      this.openedMenu = null;
    }
  }

  toggleEstado(rowData: any) {
    if (rowData.ativo) {
      this.desativarUser(rowData.userName, rowData.id);
    } else {
      this.ativarUser(rowData.userName, rowData.id);
    }
  }

  desativarUser(userName: string, id: string): void {
    if (!userName || !id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Dados inválidos para desativação.',
        life: 5000
      });
      return;
    }

    this.confirmationService.confirm({
      message: `Tem certeza que deseja desativar o usuário "${userName}"?`,
      header: 'Confirmar Desativação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.utilizadorService
          .toggleStatus(id)
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Usuário desativado com sucesso.`,
                life: 5000
              });
              this.confirmationService.close();
              this.getUtilizadores();
            },
            error: (err) => {
              this.handleError('Falha ao desativar usuário', err);
            }
          });
      },
      reject: () => {
        this.confirmationService.close();
        this.messageService.add({
          severity: 'info',
          summary: 'Ação Cancelada',
          detail: 'Desativação cancelada.',
          life: 5000
        });
      },
    });
  }

  ativarUser(userName: string, id: string): void {
    if (!userName || !id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Dados inválidos para ativação.',
        life: 5000
      });
      return;
    }

    this.confirmationService.confirm({
      message: `Tem certeza que deseja ativar o usuário "${userName}"?`,
      header: 'Confirmar Ativação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.utilizadorService
          .toggleStatus(id)
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Usuário ativado com sucesso.`,
                life: 5000
              });
              this.confirmationService.close();
              this.getUtilizadores();
            },
            error: (err) => {
              this.handleError('Falha ao ativar usuário', err);
            }
          });
      },
      reject: () => {
        this.confirmationService.close();
        this.messageService.add({
          severity: 'info',
          summary: 'Ação Cancelada',
          detail: 'Ativação cancelada.',
          life: 5000
        });
      },
    });
  }

}